import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css';

import {

    DANGER_COLOR,
    SUCCESS_COLOR,
    PRIMARY_COLOR,
    INFO_COLOR,
    WARNING_COLOR,

} from '../globals';

const toastMixin = {

    methods: {

        showNotification({
            description,
            hideProgressBar = false,
            showIcon = true,
            timeout = 4,
            title,
            type = 'success',
        }) {

            let color = '';

            switch (type) {

            case 'danger':
                color = DANGER_COLOR;
                break;

            case 'primary':
                color = PRIMARY_COLOR;
                break;

            case 'info':
                color = INFO_COLOR;
                break;

            case 'warning':
                color = WARNING_COLOR;
                break;

            default:
                color = SUCCESS_COLOR;
                break;

            }

            createToast({

                title,
                description,

            }, {

                hideProgressBar,
                position: 'top-right',
                showIcon,
                timeout: timeout * 1000,
                toastBackgroundColor: color,
                transition: 'slide',
                type,

            });

        },

    },

};

export default toastMixin;
